'use client';
var classes = {"wrapper":"m_fee9c77","preview":"m_9dddfbac","body":"m_bffecc3e","sliders":"m_3283bb96","thumb":"m_40d572ba","swatch":"m_d8ee6fd8","swatches":"m_5711e686","saturation":"m_202a296e","saturationOverlay":"m_11b3db02","slider":"m_d856d47d","sliderOverlay":"m_8f327113"};

export { classes as default };
//# sourceMappingURL=ColorPicker.module.css.mjs.map
